import { Box } from '@chakra-ui/react';
import React, { useState } from 'react';
import { Close } from '../../Icons/Close';
import { CommonProps } from '../../interfaces/components';
import ReactPlayer from 'react-player';
import CarouselItem from '../../components/common/CarouselItem';
import { Forward } from '../../Icons/Forward';
import { Eclipse } from '../../Icons/Eclipse';
import { Backward } from '../../Icons/Backward';
import Fountain from '../../assets/images/laroca/fountain.png';
import Architecture from '../../assets/images/laroca/architecture.png';
import Flowers from '../../assets/images/laroca/flowers.png';
import { useTranslation } from 'react-i18next';

const Sculpture = ({ active, setActive }: CommonProps) => {
  const { t } = useTranslation();
  const [slide, setSlide] = useState<number>(1);
  const totalSlides = 4;

  const onNext = () => {
    if (slide === totalSlides) {
      setSlide(1);
    } else if (slide < totalSlides) {
      setSlide((slide) => ++slide);
    }
  };

  const onPrev = () => {
    if (slide === 1) {
      setSlide(totalSlides);
    } else if (slide > 1) {
      setSlide((slide) => --slide);
    }
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding="0px"
        width={['100vw', '100vw', '755px', '835px']}
        height={slide === 1 ? ['100%', '100%', '520px', '580px'] : ['100%', '100%', '700px', '750px']}
      >
        <Close
          boxSize={[5, 5, 6]}
          position="absolute"
          top={['30px', '30px', '35px']}
          right={['30px', '30px', '35px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box transition="0.30s all">
          {slide === 1 && (
            <Box display="flex" flexDirection="column" m="0px" p="0px">
              <Box h={['70vh', '80vh', '425px', '470px']} bg="whitesmoke">
                {active && (
                  <ReactPlayer
                    progressInterval={1}
                    height="100%"
                    width="100%"
                    loop={true}
                    muted
                    controls={false}
                    playing={active}
                    url="https://emperia-static.s3.eu-west-2.amazonaws.com/client/bister/laroca/minahamada.mp4"
                    playsinline
                    style={{ objectFit: 'cover' }}
                  />
                )}
              </Box>

              <Box
                mt={['5', '5', '5', '7']}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                h="60px !important"
                p={['10px 10px', '10px 10px', '10px 20px', '10px 20px']}
              >
                <Backward boxSize={['40px', '50px', '50px', '60px']} cursor="pointer" onClick={onPrev} />
                <Box display="flex" gap="2">
                  {Array.from(Array(totalSlides).keys()).map((number: number) => (
                    <Eclipse
                      key={`eclipse_1_${totalSlides}_${number}`}
                      boxSize={[3, 3, 3, 4]}
                      stroke={number + 1 === 1 ? '#C29F6B' : '#000'}
                      fill={number + 1 === 1 ? '#C29F6B' : '#fff'}
                      strokeWidth="1px"
                      borderRadius="50%"
                      cursor="pointer"
                    />
                  ))}
                </Box>
                <Forward boxSize={['40px', '50px', '50px', '60px']} cursor="pointer" onClick={onNext} />
              </Box>
            </Box>
          )}
          {slide === 2 && (
            <CarouselItem
              image={Fountain}
              title={t('sculpture_slide_2_title')}
              body={t('sculpture_slide_2_description')}
              index={2}
              total={totalSlides}
              onNext={onNext}
              onPrev={onPrev}
            />
          )}
          {slide === 3 && (
            <CarouselItem
              image={Architecture}
              title={t('sculpture_slide_3_title')}
              body={t('sculpture_slide_3_description')}
              index={3}
              total={totalSlides}
              onNext={onNext}
              onPrev={onPrev}
            />
          )}
          {slide === 4 && (
            <CarouselItem
              image={Flowers}
              title={t('sculpture_slide_4_title')}
              body={t('sculpture_slide_4_description')}
              index={4}
              total={totalSlides}
              onNext={onNext}
              onPrev={onPrev}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default Sculpture;
